import { render, staticRenderFns } from "./IM_1_6.vue?vue&type=template&id=1f0f1570&scoped=true&"
import script from "./IM_1_6.vue?vue&type=script&lang=js&"
export * from "./IM_1_6.vue?vue&type=script&lang=js&"
import style0 from "./IM_1_6.vue?vue&type=style&index=0&id=1f0f1570&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f1570",
  null
  
)

export default component.exports